import type { Provider } from '@dataTypes/provider.types'

/** Clinic IDs a provider/staff row is allowed to work in (assigned + primary fallback). */
export function clinicIdsFromProvider(p: Provider): string[] {
  const fromAssigned =
    p.assigned_clinics?.map((c) => c.clinic_id).filter(Boolean) ?? []
  if (fromAssigned.length > 0) {
    return fromAssigned.filter((id, index, self) => self.indexOf(id) === index)
  }
  if (p.clinic_id) return [p.clinic_id]
  return []
}
